import React from "react";

import { ArrowBack, ChevronRight } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { useHistory, useParams } from "react-router-dom";

import { TransitionDetailsDTO } from "@fartherfinance/frontend/api/TransitionWorkflows/Types";

import { selectFirstTransitionAdvisor } from "@src/multiCustodian/pages/Advisor/TransitionWorkflows/utils";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TransitionBreadcrumbs.module.css";

interface TransitionBreadcrumbsProps {
  transition: TransitionDetailsDTO;
}

const TransitionBreadcrumbs: React.FC<TransitionBreadcrumbsProps> = ({
  transition,
}) => {
  const firstAdvisor = selectFirstTransitionAdvisor(transition?.advisors ?? []);
  const advisorNames = firstAdvisor?.fullName || "Unknown Advisor";
  const history = useHistory();
  const { transitionId } = useParams<{ transitionId?: string }>();

  const handleRedirectToAdvisor = () => {
    if (transitionId) {
      history.push(`/Advisor/Transitions/${transitionId}`);
    }
  };

  const handleRedirectToPipelineSummary = () => {
    history.push("/Advisor/Transitions");
  };

  return (
    <Box className={styles.breadcrumbs}>
      <IconButton
        onClick={handleRedirectToAdvisor}
        className={styles.backButton}
      >
        <ArrowBack />
      </IconButton>

      <Text
        variant="body"
        color="textSubtle"
        onClick={handleRedirectToPipelineSummary}
        style={{ cursor: "pointer" }}
      >
        Pipeline Summary
      </Text>

      <ChevronRight className={styles.separator} />

      <Text
        variant="body"
        color="textSubtle"
        onClick={handleRedirectToAdvisor}
        style={{ cursor: "pointer" }}
      >
        {advisorNames}
      </Text>

      <ChevronRight className={styles.separator} />

      <Text variant="body" color={"text"}>
        Onboarding Tracker
      </Text>
    </Box>
  );
};

export default TransitionBreadcrumbs;
